/* src/app/components/consent/consent-footer/consent-footer.component.scss */
.main-container {
  min-height: 100vh;
}
.apt-container {
  margin: 0;
}
.apt-container > .apt-grid,
.apt-container > .apt-grid-wrap {
  margin: 0 15px;
}
.apt-container .apt-grid.success-box {
  margin-bottom: 40px;
}
.apt-container .apt-grid.success-box .label-icon {
  font-size: 2rem;
}
.apt-container .apt-grid.success-box .label-icon img {
  width: 50px;
  height: auto;
}
.apt-container .apt-grid.success-box .label-thank-you {
  font-size: 1.6rem;
  line-height: 1.23077;
}
.apt-container .apt-grid.success-box .label-msg {
  font-size: 1.3rem;
  line-height: 1.6;
  font-weight: 600;
}
.apt-container .apt-grid.success-box .label-ref-number {
  font-size: 1.6rem;
  line-height: 1.23077;
}
.apt-container .form-action {
  text-align: left;
  margin-top: 20px;
}
.apt-container .form-action .btn {
  grid-column: span 3;
}
.comp-content {
  background-color: #f2f2f2;
}
.apt-grid,
.apt-grid-wrap {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  column-gap: 10px;
}
.apt-grid > *,
.apt-grid-wrap > * {
  grid-column: 1/-1;
}
.apt-grid-wrap > * {
  min-width: 0;
  min-height: 0;
  word-wrap: break-word;
  max-width: 100%;
}
.required-field label::after,
.required-field-label::after {
  content: " *";
  color: #e74a3b;
}
.required-field-notice {
  font-size: 0.8rem;
  margin-top: 18px;
  margin-bottom: 20px;
}
.required-field-notice::before {
  content: "* ";
  color: #e74a3b;
}
.button-like {
  min-height: 34px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  outline: 0;
  padding: 0.65em 0.75em;
  display: inline-block;
  position: relative;
  color: #212121;
  font-size: 13px;
  line-height: 1.2;
  vertical-align: middle;
  background-color: #fafafa;
  transition: none 0.4s cubic-bezier(0.19, 1, 0.22, 1);
}
.button-like--with-icon {
  padding-right: 20px;
}
.button-like__icon {
  padding: 0.1em 5px;
  border: 0;
  outline: 0;
  position: absolute;
  top: 0;
  margin-top: -2px;
  right: 0;
  background: transparent;
  color: #c4c4c4;
  appearance: none;
  font-size: 25px;
}
.custom-control-label.custom-no-text::before {
  top: -0.75rem;
  left: -1rem;
}
.custom-control-label.custom-no-text::after {
  top: -0.75rem;
  left: -1rem;
}
.inline-action {
  font-size: 1.125rem;
  color: #39393a;
  text-decoration: underline;
  cursor: pointer;
}
.modal-showroom {
  max-width: 90vw;
}
@media only screen and (min-width: 480px) {
  .apt-container > .apt-grid,
  .apt-container > .apt-grid-wrap {
    max-width: 420px;
    margin: 0 auto;
  }
}
@media only screen and (min-width: 768px) {
  .apt-container > .apt-grid,
  .apt-container > .apt-grid-wrap {
    max-width: 708px;
  }
  .modal-showroom {
    max-width: 85vw;
  }
}
@media only screen and (min-width: 1014px) {
  .required-field-notice {
    margin-top: 35px;
    margin-bottom: 40px;
    font-size: 1rem;
  }
  .apt-container > .apt-grid,
  .apt-container > .apt-grid-wrap {
    max-width: 953px;
  }
  .apt-container .form-action {
    display: flex;
    justify-content: flex-end;
  }
  .apt-container .form-action .btn:not(:last-child) {
    margin-right: 20px;
  }
  .apt-grid,
  .apt-grid-wrap {
    grid-template-columns: repeat(9, 1fr);
    column-gap: 20px;
  }
  .modal-xlg {
    max-width: 80%;
  }
}
@media only screen and (min-width: 1336px) {
  .apt-container > .apt-grid,
  .apt-container > .apt-grid-wrap {
    max-width: 1276px;
  }
  .apt-grid,
  .apt-grid-wrap {
    grid-template-columns: repeat(12, 1fr);
  }
}
.apt-container {
  font-size: 0.8rem;
  background-color: #3e4a56;
}
.apt-container.footer {
  position: absolute;
  width: 100%;
  top: 100%;
}
.apt-container .apt-grid {
  padding-top: 40px;
  padding-bottom: 40px;
}
.apt-container .apt-grid .footer-1 {
  grid-column: 1/6;
}
.apt-container .apt-grid .footer-2 {
  grid-column: 1/6;
}
.apt-container .apt-grid h5 {
  color: #fff;
}
.apt-container .apt-grid small {
  font-size: 10px;
}
.divider {
  margin: 30px 0;
  background-color: #d9d9d9;
}
.mb-10px {
  margin-bottom: 10px;
}
.line-height {
  line-height: normal;
}
@media only screen and (max-width: 768px) {
  .apt-container.footer {
    position: relative;
    width: 100%;
    bottom: 0 !important;
  }
}
@media only screen and (min-width: 1014px) {
  .apt-container .apt-grid .footer-1 {
    grid-column: span 6/6;
  }
  .apt-container .apt-grid .footer-2 {
    grid-column: span 3/-1;
    justify-self: end;
  }
}
@media only screen and (min-width: 1336px) {
  .apt-container .apt-grid .footer-1 {
    grid-column: span 6/6;
  }
  .apt-container .apt-grid .footer-2 {
    grid-column: span 3/-1;
    justify-self: end;
  }
}
/*# sourceMappingURL=consent-footer.component.css.map */
